import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  getPendingAgreement: (queryParams) => {
    return httpApi.getDataViaApi({
      url: api.agreement.pending,
      queryParams
    })
  },
  respondToAgreement: (body) => {
    return httpApi.postDataViaApi({
      url: api.agreement.respond,
      body
    })
  }
}

